import { Book, Chapter } from '../../types';
import './chapter-navigation.css';
import { useLocation, Link } from 'wouter';

interface ChapterNavigationProps {
  prevChapter?: Chapter;
  nextChapter?: Chapter;
  book: Book;
}

export const ChapterNavigation = ({
  prevChapter,
  nextChapter,
  book,
}: ChapterNavigationProps) => {
  // Get current location to extract sidebar state
  const [location] = useLocation();
  
  // Check if we have a sidebar state in the URL
  let sidebarState = null;
  const pathParts = location.split('/');
  if (pathParts.length > 5) {
    const lastPart = pathParts[5];
    if (lastPart === 'comments') {
      sidebarState = 'comments';
    } else if (lastPart === 'chapter-list') {
      sidebarState = 'chapterList';
    } else if (lastPart === 'settings') {
      sidebarState = 'settings';
    }
  }
  return (
    <div class="chapter-navigation">
      {prevChapter && (
        <Link
          role="button"
          className="secondary"
          href={
            sidebarState === 'chapterList' ? `/f/${book.permalink}/c/${prevChapter.permalink}/chapter-list` :
            sidebarState === 'comments' ? `/f/${book.permalink}/c/${prevChapter.permalink}/comments` :
            sidebarState === 'settings' ? `/f/${book.permalink}/c/${prevChapter.permalink}/settings` :
            `/f/${book.permalink}/c/${prevChapter.permalink}`
          }
        >
          Previous Chapter
        </Link>
      )}
      {!prevChapter && (
        <Link role="button" className="secondary" href={`/f/${book.permalink}`}>
          Back to Book
        </Link>
      )}
      {nextChapter && (
        <Link
          role="button"
          href={
            sidebarState === 'chapterList' ? `/f/${book.permalink}/c/${nextChapter.permalink}/chapter-list` :
            sidebarState === 'comments' ? `/f/${book.permalink}/c/${nextChapter.permalink}/comments` :
            sidebarState === 'settings' ? `/f/${book.permalink}/c/${nextChapter.permalink}/settings` :
            `/f/${book.permalink}/c/${nextChapter.permalink}`
          }
        >
          Next Chapter
        </Link>
      )}
    </div>
  );
};
